class AE2Cart {

    constructor()
    {
        this.loading_screen = $('#ae2-loading-screen');

        if( 
            ae2_url === undefined || 
            ae2_token === undefined ){ return }

        this.url = ae2_url;
        this.token = ae2_token;
        this.load();
    }

    load()
    {

        let cart_details = $('.ae2-cart-detail');

        $.each( cart_details, function(k, cart_detail){

            let design = $(cart_detail).data('design');

            let formData = new FormData();
            formData.append('action', 'getDesignImage');
            formData.append('params[design]', parseInt(design));
            formData.append('token', this.token);

            $.ajax({
                type: 'POST',
                dataType: 'JSON',
                url: this.url,
                contentType: false,
                processData: false,
                data: formData,
                context : this,
                'success' : function(response){
                    if(response.success && response.img_url != '')
                    {
                        let img_elements = $(cart_detail).find('.product-img--main');

                        console.log(response.img_url, img_elements);
                        if(img_elements.length){

                            let img_element = img_elements.get(0);
                            $(img_element).data('image', response.img_url)
                                .on('mouseover', function(){
                                    $(this).children('.product-img--main__image').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
                                    })
                                .on('mouseout', function(){
                                    $(this).children('.product-img--main__image').css({'transform': 'scale(1)'});
                                })
                                .on('mousemove', function(e){
                                    $(this).children('.product-img--main__image').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
                                })
                                .each(function(){
                                    $(this).append('<div class="product-img--main__image"></div>').children('.product-img--main__image').css({'background-image': 'url('+ response.img_url +')'});
                                });
                        }
                    }
                },
                'error' : function(){

                }
            });
            

        }.bind(this));


        this.loadEvents();
    }

    loadEvents()
    {
        prestashop.on(
            'updatedCart',
            function (event) {
                console.log('reloading');
                ae2cart.load();
           }
        );
        
        /*
        const edit_inputs = document.querySelectorAll('.edit-design-btn');

        if(edit_inputs){

            edit_inputs.forEach( function(edit_input){

                edit_input.addEventListener('click', function(e){

                    let action = $(e.currentTarget).data('action');
                    let params = $(e.currentTarget).data('params');
                    if(params === undefined){
                        params = {};
                    }else{
                        params = ae2cart.parseParams(params);
                    }

                    if(action){
                        ae2cart.handleAction(action, params);
                    }
                });
            });
        }
        */
    }


    handleAction(action, params = {})
    {
        this.clearMessage();
        console.log('//START ACTION//');
        console.log(params, action);

        switch (action) {

            case 'edit':

                let formData = new FormData();
                formData.append('action', 'editDesign');
                formData.append('params[design]', parseInt(params.design));
                formData.append('token', this.token);

                $.ajax({
                    type: 'POST',
                    dataType: 'JSON',
                    url: this.url,
                    contentType: false,
                    processData: false,
                    data: formData,
                    context : this,
                    'success' : function(response){

                        console.log(response);

                        if(response.success)
                        {

                        }
                    },
                    'error' : function(){

                    }
                });  

                break;

            default:
                break;
        }
        
    }



    clearMessage = () =>
    {
        $('#notifications').empty();
    }

    dropMessage = (message, error = true) =>
    {
        this.clearMessage();
        if(error){
            var strNotification = `<article class="alert alert-danger" role="alert" data-alert="danger"><ul><li>` +message+ `</li></ul></article>`;
        }else{
            var strNotification = `<article class="alert alert-success" role="alert" data-alert="success"><ul><li>` +message+ `</li></ul></article>`;
        }
        $('#notifications').html(strNotification);
    }

    parseParams(params)
    {
        params = String(params);
        params = params.replaceAll('\'', '"');
        params = params.replaceAll('[', '{');
        params = params.replaceAll(']', '}');
        return JSON.parse(params);

    }

}
const ae2cart = new AE2Cart();